var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoVirus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0089 11L13.4307 13.8041V23.0423C13.4307 31.0774 18.4574 38.2541 26.0089 41C33.5603 38.2541 38.587 31.0774 38.587 23.0423V13.8041L26.0089 11Z",
    fill: "url(#paint0_linear_7240_24241)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6851 24.8084C30.6851 26.052 30.1807 27.1779 29.3658 27.9927C28.5509 28.8076 27.4251 29.312 26.1814 29.312C23.6941 29.312 21.6777 27.2956 21.6777 24.8084C21.6777 23.5647 22.1822 22.4388 22.997 21.624C23.3483 21.2726 23.7569 20.9793 24.2083 20.7591C24.4145 21.6581 25.2196 22.329 26.1814 22.329C27.1433 22.329 27.9484 21.6581 28.1545 20.7591C28.6059 20.9793 29.0145 21.2726 29.3658 21.624C30.1807 22.4388 30.6851 23.5647 30.6851 24.8084Z",
    fill: "url(#paint1_linear_7240_24241)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.204 20.305C28.204 21.423 27.2977 22.3293 26.1796 22.3293C25.0616 22.3293 24.1553 21.423 24.1553 20.305C24.1553 19.187 25.0616 18.2807 26.1796 18.2807C27.2977 18.2807 28.204 19.187 28.204 20.305Z",
    fill: "url(#paint2_linear_7240_24241)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.422 22.3293L21.0039 20.5417V18.8962",
    stroke: "#8C74ED",
    strokeWidth: 1.21951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.422 27.2761L21.0039 29.0637V30.7092",
    stroke: "#8C74ED",
    strokeWidth: 1.21951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6782 24.8083H19.6616L18.5303 23.6771",
    stroke: "#8C74ED",
    strokeWidth: 1.21951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9492 22.3293L31.3673 20.5417V18.8962",
    stroke: "#8C74ED",
    strokeWidth: 1.21951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9492 27.2761L31.3673 29.0637V30.7092",
    stroke: "#8C74ED",
    strokeWidth: 1.21951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6865 24.8083H32.7032L33.8344 23.6771",
    stroke: "#8C74ED",
    strokeWidth: 1.21951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1787 22.3292V24.2427",
    stroke: "white",
    strokeWidth: 1.21951,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 25,
    r: 21,
    stroke: "#3BB408",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 42.1075,
    y1: 11.4071,
    x2: 12.4075,
    y2: 41.1071,
    stroke: "#3BB408",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7240_24241",
    x1: 26.0089,
    y1: 41,
    x2: 26.0089,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#43D80E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5F148"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7240_24241",
    x1: 26.0013,
    y1: 22.0526,
    x2: 26.0013,
    y2: 29.5526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B43BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5956F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7240_24241",
    x1: 26.1796,
    y1: 22.3293,
    x2: 26.1796,
    y2: 18.2807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E59BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD90FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoVirus);
export default __webpack_public_path__ + "static/media/icon_no_virus.bf33cbab6489798f34921773cb97a8ca.svg";
export { ForwardRef as ReactComponent };